import styled from "styled-components";
import { Form, Button, Input, Row, Col, Select } from "library";
import { Body4 } from "components/Typography";
import { PAISES_EIDU, filtrarPaisOpcion } from "utilites/eiduForm";

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

interface Paso1Props {
  onContinue: (values: {
    nombre: string;
    pais: string;
    identificacion: string;
  }) => void;
  isLoading?: boolean;
}

export function Paso1Identificacion({
  onContinue,
  isLoading = false,
}: Paso1Props) {
  return (
    <FormContainer>
      <Body4 style={{ color: "#000000", marginBottom: 24, fontSize: 20, lineHeight: "28px" }}>
        Paso 1 de 2 — Ingrese sus datos básicos para continuar.
      </Body4>
      <Form {...formItemLayout} onFinish={onContinue} name="eidu-paso1">
        <Row gutter={32}>
          <Col xs={24} lg={12}>
            <Form.Item
              label="Nombre completo"
              name="nombre"
              rules={[{ required: true, message: "Campo requerido" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="País"
              name="pais"
              rules={[{ required: true, message: "Campo requerido" }]}
            >
              <Select
                options={PAISES_EIDU}
                placeholder="Seleccionar o buscar país"
                showSearch
                optionFilterProp="label"
                filterOption={filtrarPaisOpcion}
              />
            </Form.Item>
            <Form.Item
              label="Identificación personal (Número de cédula)"
              name="identificacion"
              normalize={(value) =>
                value == null ? value : String(value).replace(/\D/g, "")
              }
              rules={[
                { required: true, message: "Campo requerido" },
                {
                  pattern: /^\d+$/,
                  message: "Solo se permiten números",
                },
              ]}
            >
              <Input inputMode="numeric" placeholder="Digite únicamente números" />
              </Form.Item>
            <Button htmlType="submit" disabled={isLoading} block>
              {isLoading ? "Consultando..." : "Continuar"}
            </Button>
          </Col>
        </Row>
      </Form>
    </FormContainer>
  );
}

const FormContainer = styled.div`
  .ant-form-item {
    margin-bottom: 24px;
    position: relative;
  }
  .ant-select-dropdown {
    left: 0 !important;
    min-width: 100% !important;
  }
  .ant-form-item-label {
    padding-bottom: 0;
  }
  label {
    font-size: 12px;
    line-height: 19px;
    font-weight: normal;
    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;
